import { Box, Center, Image, Spacer, Text } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import { useCardTargetTokens } from '@ui/views/card-cronos/core/configs/token';
import { useCardContextStore } from '@ui/views/card-cronos/core/useCardContextStore';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

import { TopUpInfo } from './TopUpInfo';
import { TopUpInput } from './TopUpInput';

export const TopUp = () => {
  const t = useTranslations();
  const { token } = useCardContextStore();
  const toTokens = useCardTargetTokens();
  const needToSwap = useMemo(
    () =>
      toTokens.every(
        (t) => t.address.toLowerCase() !== token.address.toLowerCase(),
      ),
    [toTokens, token],
  );
  return (
    <Box>
      <TopUpInput />
      <Spacer h="40px" />
      <TopUpInfo />
      <Center gap="1" mt="40px">
        {needToSwap && (
          <>
            <Text textStyle="overline" textTransform="uppercase">
              {t('card.powered by')}
            </Text>
            <Image
              src={getAssetUrl('/images/vvs-horizontal-logo.png')}
              width="112px"
              height="auto"
              alt="h2"
            />
          </>
        )}
      </Center>
    </Box>
  );
};
